import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import config from '@/config';
import api from '@/shared/api';
import messages from '../fileViewerMessages';
import LoadingAnimation from '@/shared/components/LoadingAnimation';

class OutlookMsgViewer extends Component {
  state = {
    emailHtml: undefined,
  };

  retrieveMsgPreview(documentId) {
    this.setState({ loading: true });

    api.base.get(`${config.appUrls.documents}/api/emails/PreviewMsg/${documentId}`).then(
      ({ data }) => {
        this.setState({ emailHtml: data, loading: false });
      },
      error => {
        this.setState({ loading: false });
        console.error(error);
      },
    );
  }

  componentDidMount() {
    const { documentId } = this.props;
    this.retrieveMsgPreview(documentId);
  }

  render() {
    const { emailHtml, loading } = this.state;
    if (!emailHtml && !loading) {
      return <FormattedMessage {...messages.NoPreviewAvailableForThisDocument} />;
    }
    if (loading) {
      return <LoadingAnimation />;
    }

    return (
      <iframe
        title="Preview"
        sandbox=""
        style={{ border: 'none', width: '100%', height: '100%' }}
        srcDoc={emailHtml}
      />
    );
  }
}

export default OutlookMsgViewer;
